/**
 * @typedef {Object} Word
 * @property {string=} id
 * @property {string=} word
 * @property {boolean=} ignoreSpaces
 */

/**
 * @typedef {Object} WordService
 * @property {function(): angular.IPromise<Word[]>} get
 * @property {function(string): angular.IPromise<Word>} delete
 * @property {function(Word): angular.IPromise<Word>} post
 * @property {function(string, Word): angular.IPromise<Word>} patch
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {WordService}
 */
function bahabotWordFactory($resource, $q) {
    const Words = $resource('/api/protected/words', {}, {
        get:    { method: 'GET' },
    });

    const Word = $resource('/api/protected/words/:id', {}, {
        get:    { method: 'GET' },
        patch:  { method: 'PATCH' },
        post:   { method: 'POST' }
    });

    return {
        get: function() {
            return Words.get().$promise.then(res => res.data);
        },
        delete: function(id) {
            return Word.delete({ id }).$promise.then(res => res.data)
        },
        patch: function(id, word) {
            return Word.patch({ id }, word).$promise.then(res => res.data)
        },
        post: function(word) {
            return Word.post(word).$promise.then(res => res.data)
        }
    };
}

mod.factory('WordService', ["$resource", bahabotWordFactory]);
